export default __webpack_public_path__ + "static/media/text.aa9e116e.png";